export default "__VITE_ASSET__BGzCiHZE__"